import { HeaderApp } from './HeaderApp';
import { registerReactWebComponent, parseListAttribute } from '@/core/utils/webComponent';

const extractHeaderProps = (element) => {
  const params = new URLSearchParams(globalThis.location?.search || '');

  const getCombinedValue = (attr, camelParam) =>
    element.getAttribute(attr) || params.get(camelParam) || params.get(attr);

  return {
    filterLabels: parseListAttribute(getCombinedValue('filter-labels', 'filterLabels')) || [],
    userData: parseListAttribute(getCombinedValue('user-data', 'userData')),
    hideFilterBar: getCombinedValue('hide-filter-bar', 'hideFilterBar') === 'true',
    hideTopBar: getCombinedValue('hide-top-bar', 'hideTopBar') === 'true',
    hideLanguageSelector: getCombinedValue('hide-language-selector', 'hideLanguageSelector') === 'true',
    hideSearchBar: getCombinedValue('hide-search-bar', 'hideSearchBar') === 'true',
    hideReprocessingStatus: getCombinedValue('hide-reprocessing-status', 'hideReprocessingStatus') === 'true',
    hideSidebarButton: getCombinedValue('hide-sidebar-button', 'hideSidebarButton') === 'true',
    hideCopyFilterIdButton: getCombinedValue('hide-copy-filter-id-button', 'hideCopyFilterIdButton') === 'true',
    hideClearFilterButton: getCombinedValue('hide-clear-filter-button', 'hideClearFilterButton') === 'true',
    reprocessingStatus: getCombinedValue('reprocessing-status', 'reprocessingStatus'),
    availableItems: parseListAttribute(getCombinedValue('available-items', 'availableItems')) || [],
    lockRefreshInterval: getCombinedValue('filter-fixed-24h', 'filterFixed24h') === 'true',
    showGlobalFilter: getCombinedValue('show-global-filter', 'showGlobalFilter') === 'true',
    excludedChannelKeys: parseListAttribute(getCombinedValue('excluded-channel-keys', 'excludedChannelKeys')) || [],
  };
};

export const registerHeaderComponent = () => {
  registerReactWebComponent('content-header', HeaderApp, extractHeaderProps);
};
